"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormData = void 0;
var tables_1 = require("../../tables/tables");
var Utils_1 = require("../../Utils");
var schema_1 = require("./schema");
function createFormData(tab, config, model) {
    var _a;
    var formData = {};
    if (config) {
        var components = model.getAutoModuleAppModel().getAllComponents();
        (_a = (0, Utils_1.values)(components)) === null || _a === void 0 ? void 0 : _a.forEach(function (entry) {
            var _a;
            if (!config) {
                return;
            }
            var component = entry.component;
            var value = model.getComponentValue(component.name);
            if (component.type === "boolean" &&
                (value === config.booleanValues.true ||
                    value === config.booleanValues.false)) {
                value = value === config.booleanValues.true;
            }
            if (component.type === "DescriptionOnly") {
                value = null;
            }
            if ((0, schema_1.isInvalidTab)(component.tabs, tab)) {
                return;
            }
            if (component.category === "table") {
                value = (0, tables_1.getTableFormData)(model, component, tab);
            }
            formData[component.group] = __assign(__assign({}, formData[component.group]), (_a = {}, _a[component.name] = value, _a));
        });
    }
    return formData;
}
exports.createFormData = createFormData;
//# sourceMappingURL=formData.js.map